<template>
  <article>
    <loading :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="fullPage"></loading>
    <div class="itmdtlimg">
      <ul class="itmdtlimgvalU itmdtlimgvalU-nml" id="itmdtlimgU" :style="imgsWidth">
        <li class="itmdtlimgval itmdtlfcs inlblk" v-for="img in imgs.L" v-html="img">
        </li>
      </ul>
    </div>
    <Itemhead v-bind:detail="detail" />
    <div class="entry-content">
      <ItemEclist v-bind:eclist="eclist" />
      <div class=" pcinner">
        <h2 class="rltttl httl1 mh"><router-link :to="'/brand/' +  detail.brand_code + '/items/' + detail.gender_code + '/' +  detail.category_code">{{detail.brand_name_en}}の新着{{detail.gender_name}}{{detail.category_name}}</router-link></h2>
        <ItemList v-bind:ItemList="relList" v-bind:ItemTotal="false" />
      </div>
    </div>
  </article>
</template>

<script>
  import Itemhead from '@/components/items/head.vue'
  import ItemEclist from '@/components/items/eclist.vue'
  import ItemList from '@/components/ItemList.vue'
  import axios from 'axios'
  import lazysizes from 'lazysizes'
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { mapMutations } from 'vuex'
  import isMobile from 'ismobilejs'

  export default {
    name: 'items',
    components: {
      Itemhead,
      ItemEclist,
      Loading,
      ItemList
    },
    data () {
      return {
        detail: [],
        imgs: [],
        imgsWidth: 0,
        eclist: [],
        isLoading: false,
        fullPage: true,
        relMore: false,
        relList: {},
        relTotal: 0,
        // viewed: []
      }
    },
    beforeRouteUpdate(to, from, next) {
      // toが遷移先、fromが遷移元の $route
      this.initialize()
      this.setupPage(to)
      // 続きの処理を実行
      this.setEC(to)
      next();
    },
    mounted: function(){
      let id = this.$route.params.id
      this.initialize()
      this.setupPage(this.$route)
      this.setEC(this.$route)
      // console.log(localStorage.viewed)
    },
    methods: {
      initialize() {
        this.refresh();
      },
      refresh() {
        this.detail = {}
        this.imgs = {}
        this.eclist = {}
        this.relList = {}
        this.relTotal = 0
      },
      setupPage(route) {
        this.isLoading = true
        const id = route.params.id;
        axios.get('https://app3.sportsstyle.net/items/' + id)
        .then((res) => {
          this.detail = res.data
          let title = this.detail.brand_name_full + " " + this.detail.name  + " [" + this.detail.maker_item_code + "]"
          let description = title + 'のアイテムページ。購入できる通販サイトの比較や、関連アイテム情報など。'
          this.setHeader(title, description, true)
          this.setImgs(id)
          this.isLoading = false
          this.getRelItem(id)
          this.$store.commit('chageHeadTitle', this.detail.brand_name_full + " " + this.detail.name)

        })
        .catch(() =>{
          console.log('not found')
        })
        this.addViewed(id)
      },
      setImgs(id){
        axios.get('https://app3.sportsstyle.net/items/' + id + '/imgs.json')
        .then((res) => {
          this.imgs = res.data
          this.imgsWidth = "width: " + this.imgs.count * 280 + "px;"
        })
        .catch(() =>{
          console.log('imgs not found')
        })
      },
      setEC(route){
        const id = parseInt(route.params.id);
        axios.get('https://app3.sportsstyle.net/items/' + id + '/eclist')
        .then((res) => {
          this.eclist = res.data
        })
        .catch(() =>{
          console.log('eclist not found')
        })
      },
      getRelItem(id){
        const url = 'https://app3.sportsstyle.net/items/' + id + "/catitems"
        axios.get(url)
        .then((res) => {
          this.relList = res.data.list
          this.relTotal = res.data.total
          if(this.relTotal > 15){
            this.relMore = true;
          }
        })
        .catch(() =>{
          console.log('rel item not found')
        })
      },
      addViewed(id){
        let viewed =[]
        if (localStorage.getItem('viewed')) {
          viewed = JSON.parse(localStorage.getItem('viewed'))
        }
        viewed.push(parseInt(id))
        localStorage.setItem('viewed', JSON.stringify(viewed));
      }
    }
  }
</script>

<style scoped>
.itmdtlimg{width: 100%; overflow: hidden; text-align: center; margin: 8px auto; position: relative; height: 320px; overflow-x: scroll; text-align: center; -webkit-overflow-scrolling: touch;}
.itmdtlimgval{width: 100%; height: 380px; overflow: hidden;}
.itmdtlimgvalU {display: flex;}
.itmdtlimgval{width: 280px;}
.itmdtlimgval a{display: block;}
.lazyloaded{max-width: 100%;}
.itmdtlnml img{opacity: 0.65;}
.itmdtlfcs img{opacity: 1;}
.itmdtlimgvalU{margin: 0 auto; left: 0; top: 0; overflow: hidden; position: absolute; transition-duration: 0.5s;}
.itmdtlimgvalU-nml{position: relative;}

.itmdtlimgprv, .itmdtlimgfwd{width: 80px; height: 100%; position: absolute; cursor: pointer; display: table-cell; vertical-align: middle;}
.itmdtlimgprv{top: 0; left: 315px;}
.itmdtlimgfwd{top: 0; right: 255px;}
.back-btn{
  color: skyblue;
  font-size: 1.2rem;
  display: inline-block;
  padding: 4px 8px;
  cursor: pointer;
}
.rltttl {
  text-align: left;
  padding: 16px 8px;
  margin: 0 0 16px;
  font-weight: bold;
  border-bottom: 1px solid #EEE;
}
.rltttl a{
  font-size: .9rem;
  text-decoration: none;
  color: #666;
  line-height: 16px;
  display: flex;
  align-items: center;
  position: relative;
}
.rltttl a:after{
    font-family: "Font Awesome 5 Free";
    content: "\F054";
    font-weight: 900;
    position: absolute;
    right: 8px;
    color: #AAA;
    line-height: 16px;
}
</style>
